export default class TrendsActions {
    constructor(rootStore, api) {
        this._rootStore = rootStore;
        this._API = api;
    }

    clearPost() {
        return this._rootStore.trends.clearPost();
    }

    loadPosts() {
        return this._API.Blog.getFeaturedBlogPosts()
            .then(featuredPosts => {
                this._rootStore.trends.loadFeaturedPostsSuccess(featuredPosts);
                return this._API.Blog.getAllBlogPosts();
            })
            .then(posts => this._rootStore.trends.loadPostsSuccess(posts))
            .catch(err => {
                console.error(err);
            });
    }

    loadMorePosts() {
        return this._rootStore.trends.loadMorePosts();
    }

    loadPostByUrlPath(params, removeHtmlBody) {
        return this._API.Blog.getBlogPostByUrlPath(params)
            .then(res => {
                if (!res) {
                    return this._rootStore.trends.redirectTo404();
                }

                if (removeHtmlBody) {
                    res.htmlBody = '';
                }

                this._rootStore.trends.loadPostByUrlPathSuccess(res);
            })
            .catch(err => {
                return this._rootStore.trends.redirectTo404();
            });
    }

    updateBlogRoutes() {
        return this._API.Blog.getAllBlogPosts()
            .then(posts =>
                posts.map(post => {
                    return {
                        id: post.id,
                        blogPostUrlPath: post.blogPostUrlPath
                    };
                })
            )
            .then(routeMap =>
                this._rootStore.trends.loadPostRoutesSuccess(routeMap)
            )
            .catch(err => {
                console.error(err);
            });
    }
}



// WEBPACK FOOTER //
// ./src/common/actions/TrendsActions.js